export default "__VITE_ASSET__DE3LWFO8__"